import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { MarqueeStrip } from "@/components/site/MarqueeStrip";
import { About } from "@/components/site/About";
import { Expertise } from "@/components/site/Expertise";
import { Manifesto } from "@/components/site/Manifesto";
import { Career } from "@/components/site/Career";
import { Results } from "@/components/site/Results";
import { Testimonials } from "@/components/site/Testimonials";
import { Contact } from "@/components/site/Contact";

export default function Home() {
  return (
    <main data-testid="home-page" className="relative bg-[#ffffff]">
      <Nav />
      <Hero />
      <MarqueeStrip />
      <About />
      <Expertise />
      <Manifesto />
      <Career />
      <Results />
      <Testimonials />
      <Contact />
    </main>
  );
}
